module.exports = __webpack_public_path__ + "static/img/img-box.4aaca845.jpg";